import { render, staticRenderFns } from "./VContentTableDefault.vue?vue&type=template&id=68dbb7c9"
import script from "./VContentTableDefault.vue?vue&type=script&lang=js"
export * from "./VContentTableDefault.vue?vue&type=script&lang=js"
import style0 from "./VContentTableDefault.vue?vue&type=style&index=0&id=68dbb7c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports